var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 65,
    viewBox: "0 0 321 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.402 64.1523H1.57628C1.59802 64.1123 1.62054 64.0707 1.64382 64.0276C1.94674 63.4668 2.37897 62.6527 2.89741 61.637C3.93408 59.6061 5.31648 56.7672 6.69927 53.5353C9.45547 47.0936 12.2487 39.0114 12.2487 32.6523C12.2487 26.2933 9.45547 18.2111 6.69927 11.7694C5.31648 8.53753 3.93408 5.69863 2.89741 3.66767C2.37897 2.65199 1.94674 1.83787 1.64382 1.27713C1.62054 1.23403 1.59802 1.19243 1.57628 1.15234H309.402C309.481 1.29554 309.592 1.49734 309.73 1.75271C310.03 2.30737 310.459 3.11456 310.975 4.12257C312.005 6.13899 313.38 8.95693 314.754 12.163C317.511 18.5971 320.23 26.5148 320.23 32.6523C320.23 38.7899 317.511 46.7076 314.754 53.1417C313.38 56.3478 312.005 59.1657 310.975 61.1821C310.459 62.1901 310.03 62.9973 309.73 63.552C309.592 63.8073 309.481 64.0091 309.402 64.1523Z",
    fill: "black",
    stroke: "#9819C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape2.1dad5c1137b58c685f9ba4a8ddffd33c.svg";
export { ForwardRef as ReactComponent };